import { render, staticRenderFns } from "./InvestmentSuccessDialog.vue?vue&type=template&id=96028d96&scoped=true&"
import script from "./InvestmentSuccessDialog.vue?vue&type=script&lang=js&"
export * from "./InvestmentSuccessDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96028d96",
  null
  
)

export default component.exports